<div #content class="position-absolute text-nowrap" style="visibility: hidden"><ng-content /></div>
